import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../../../components/forms/FormField';
import municipios from '../../../data/municipios.json';

export default function IdentificacaoMunicipio() {
  const { setValue, watch, control } = useFormContext();

  // Observa mudanças no nome do município
  React.useEffect(() => {
    const nomeMunicipio = watch('nome_municipio');
    const municipio = municipios.find(m => m.municipio === nomeMunicipio);
    if (municipio) {
      setValue('codigo_ibge', municipio.codigo_ibge);
    } else if (nomeMunicipio === '') {
      setValue('codigo_ibge', '');
    }
  }, [watch('nome_municipio')]);

  const posicaoGeografica = watch('posicao_geografica');
  const mostraOutraPosicao = Array.isArray(posicaoGeografica) && posicaoGeografica.includes('outra');

  return (
    <div>
    <div className="mb-6 p-4 bg-blue-50 rounded-lg">
      <p className="text-sm text-blue-700">Esta seção coleta informações básicas sobre o município ou localidade. Preencha com os dados mais atualizados disponíveis.</p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        name="nome_municipio"
        label="Nome do município ou localidade"
        type="select"
        options={municipios.map(m => ({ value: m.municipio, label: m.municipio }))}
        className="[&_.input]:bg-gray-50"
        required
        helpText="Selecione o município da lista"
      />
      
      <FormField
        name="codigo_ibge"
        label="Código do Município (IBGE)"
        type="number"
        placeholder="Código será preenchido automaticamente"
        disabled
        className="cursor-not-allowed"
        helpText="Código de 7 dígitos do IBGE (preenchido automaticamente)"
      />
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <FormField
        name="populacao"
        label="População estimada"
        type="numeric"
        thousandSeparator="."
        decimalSeparator=","
        placeholder="Digite a população estimada"
        helpText="População conforme última estimativa oficial"
      />

      <FormField
        name="area"
        label="Área territorial (km²)"
        type="numeric"
        thousandSeparator="."
        decimalSeparator=","
        suffix=" km²"
        placeholder="Digite a área territorial"
        helpText="Área em quilômetros quadrados"
      />
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <FormField
        name="idhm"
        label="IDH Municipal"
        type="decimal3"
        placeholder="Digite o IDH Municipal"
        helpText="Índice de Desenvolvimento Humano Municipal (0,000 a 1,000)"
        validation={{
          validate: (value) => {
            if (value === undefined || value === '') return true;
            return (value >= 0 && value <= 1) || 'O valor deve ser entre 0,000 e 1,000';
          }
        }}
      />
      
      <FormField
        name="gini"
        label="Índice de Gini"
        type="decimal3"
        placeholder="Digite o Índice de Gini"
        helpText="Índice de desigualdade (0,000 a 1,000)"
        validation={{
          validate: (value) => {
            if (value === undefined || value === '') return true;
            return (value >= 0 && value <= 1) || 'O valor deve ser entre 0,000 e 1,000';
          }
        }}
      />
    </div>
    
    <div className="mt-4">
      <FormField
        name="posicao_geografica"
        label="Posição geográfica na RIDE"
        type="checkbox"
        options={[
          { value: 'central', label: 'Central' },
          { value: 'semi_periferica', label: 'Semi-periférica' },
          { value: 'periferica', label: 'Periférica' },
          { value: 'outra', label: 'Outra' },
        ]}
        helpText=""
      />
      
      {mostraOutraPosicao && (
        <div className="mt-2">
          <FormField
            name="posicao_geografica_outra"
            label="Especifique outra posição geográfica"
            placeholder="Descreva a posição geográfica"
            helpText="Preencha apenas se selecionou 'Outra' acima"
          />
        </div>
      )}
    </div>
    <hr className="border-t border-gray-300 my-6" />
    <div className="mt-6 space-y-4">
      <FormField
        name="fontes_principais_secao1"
        label="Fontes principais"
        type="textarea"
        placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
        helpText=""
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
      
      <FormField
        name="links_acesso_secao1"
        label="Links de acesso"
        type="textarea"
        placeholder="Insira os links para acesso às fontes"
        helpText="Informe URLs para acesso às fontes quando disponível"
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
    </div>
  </div>
  );
}
